import './styles.scss';
import React from 'react';
import {IRankedVendor} from "../../../api/Analytics/Analytics.types";
import {Card, Col, Row, Statistic} from "antd";
import NumbersUtil from "../../../global/utils/number";
import {DollarOutlined, GroupOutlined, NodeIndexOutlined} from "@ant-design/icons";

interface Props {
    data: IRankedVendor[]
}

function ContractsTotals({data}: Props) {

    function getTotals() {
        let totalSpent = 0;
        let numCompanies = data?.length;
        let numActions = 0;


        data?.forEach(vendor => {
            totalSpent += vendor.totalDollars;
            numActions += vendor.actions;
        })

        return {totalSpent, numCompanies, numActions}
    }

    return (
        <Row gutter={24} style={{marginBottom:24}}>
            <Col span={8}>
                <Card>
                    <Statistic
                        title={<div className='total-statistic'><DollarOutlined/> Total Spent</div>}
                        value={"$" + NumbersUtil.toShortened(getTotals().totalSpent, 2)}
                        valueStyle={{color: '#3f8600'}}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title={<div className='total-statistic'><GroupOutlined/> Total Companies</div>}
                        value={getTotals().numCompanies}
                        valueStyle={{color: '#3f8600'}}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title={<div className='total-statistic'><NodeIndexOutlined/> Total Actions</div>}
                        value={NumbersUtil.toShortened(getTotals().numActions, 2)}
                        valueStyle={{color: '#3f8600'}}
                    />
                </Card>
            </Col>
        </Row>
    )
}

export default ContractsTotals;